module.exports = __webpack_public_path__ + "img/f92dbe2.jpg";